import api from '@/apis/pa/pAPersonalIncomeTaxAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pAPersonalIncomeTax', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_personal_income_tax',
    field: {
      key: 'ref_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu xuất khẩu báo cáo
   * @param {*} context
   * @param {*} payload
   * @returns
   * NHANH3 17.1.2023
   */
  async export(context, payload) {
    return await api.export(payload);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
